import { ref, computed, watch } from "vue";
import { useStore } from "vuex";

export default function useFilterOptions(filterType) {
  const store = useStore();

  const device_filter = computed(
    () => store.getters["devicesFilterOptions/getFilterOptions"]
  );
  const loading = computed(
    () => store.getters["devicesFilterOptions/getLoading"]
  );
  const deviceQuery = computed(() => store.getters["devices/getDeviceQuery"]);

  let devicesFilter = deviceQuery.value;

  let courses = computed(() => store.getters["courses/getCourseNames"]);

  const course = ref([]);
  const deviceType = ref([]);
  const deviceClass = ref([]);
  const tagAppVersion = ref([]);
  const appVersion = ref([]);
  const unassignedStatus = ref("");
  const provider = ref([]);
  const filteredDevices = ref([]);
  const windtagDeviceClass = ref([]);
  const primaryCourses = computed(() => device_filter.value?.courses || []);
  const deviceTypes = computed(() => device_filter.value?.deviceTypes || []);
  const deviceClasses = computed(() => device_filter.value?.deviceClass || []);
  const windtagDeviceClasses = computed(
    () => device_filter.value?.windtagDeviceClass || []
  );
  const sfTagAppVersions = computed(
    () => device_filter.value?.sfTagAppVersions || []
  );
  const sfAppVersions = computed(
    () => device_filter.value?.sfAppVersions || []
  );
  const providers = computed(() => device_filter.value?.providers || []);

  watch(course, (newValue) =>
    updateActiveFilters(
      "courses",
      newValue.map((item) => item.id)
    )
  );
  watch(deviceType, (newValue) =>
    updateActiveFilters(
      "device_types",
      newValue.map((item) => item.id)
    )
  );
  watch(deviceClass, (newValue) =>
    updateActiveFilters(
      "device_classes",
      newValue.map((item) => item.id)
    )
  );
  watch(tagAppVersion, (newValue) =>
    updateActiveFilters(
      "sf_tagmarshal_app_version",
      newValue.map((item) => item.sf_tagmarshal_app_version)
    )
  );
  watch(appVersion, (newValue) =>
    updateActiveFilters(
      "sf_app_versions",
      newValue.map((item) => item.sf_app_version)
    )
  );
  watch(provider, (newValue) =>
    updateActiveFilters(
      "providers",
      newValue.map((item) => item.id)
    )
  );
  watch(windtagDeviceClass, (newValue) =>
    updateActiveFilters(
      "device_classes",
      newValue.map((item) => item.id)
    )
  );
  watch(unassignedStatus, (newValue) =>
    updateActiveFilters("unassigned", newValue)
  );

  const updateActiveFilters = (key, value) => {
    if (Array.isArray(value) && value.length > 0) {
      devicesFilter[key] = value;
    } else if (typeof value === "string" && value !== "") {
      devicesFilter[key] = value;
    } else {
      delete devicesFilter[key];
    }

    store.dispatch("devices/setDeviceQuery", devicesFilter);
  };

  const filterDevices = async () => {
    try {
      // Set filterApplied flag to indicate explicit filter action
      devicesFilter.filterApplied = true;
      store.dispatch("devices/setDeviceQuery", devicesFilter);

      if (filterType === "archivedDevices") {
        await store.dispatch("devices/fetchArchivedDevices");
      } else if (filterType === "windtagDevices") {
        await store.dispatch("windtagDevices/fetchWindtagDevices");
      } else {
        await store.dispatch("devices/fetchDevices");
      }
    } catch (error) {
      console.log(error);
    }
  };

  return {
    loading,
    course,
    courses,
    deviceType,
    deviceClass,
    tagAppVersion,
    appVersion,
    unassignedStatus,
    provider,
    primaryCourses,
    deviceTypes,
    deviceClasses,
    windtagDeviceClass,
    windtagDeviceClasses,
    sfTagAppVersions,
    sfAppVersions,
    providers,
    filterDevices,
    filteredDevices,
  };
}
